import { getNumberAttribute, getValue } from '../utilities';

let timer;

/**
 * Parse data contained in passed HTML slide
 * @param {HTMLElement} slide
 */
function parseSlideData(slide, type) {
  if (type == 'history') {
    const year = getValue(slide, 'year');
    const rows = getValue(slide, 'row', true);
    const aumLabel = getValue(slide, 'aum-label');
    const aumValue = getValue(slide, 'aum-value');

    return {
      year,
      rows,
      aumLabel,
      aumValue,
    };
  } else if (type == 'teaser' || type == 'thumbs') {
    const teaserImage = getValue(slide, 'teaserImage');
    const teaserTitle = getValue(slide, 'teaserTitle');
    const teaserIntro = getValue(slide, 'teaserIntro');
    const teaserLink = getValue(slide, 'teaserLink');
    const teaserCTA = getValue(slide, 'teaserCTA');

    return {
      teaserImage,
      teaserTitle,
      teaserIntro,
      teaserLink,
      teaserCTA,
    };
  } else {
    const articleImage = getValue(slide, 'articleImage');
    const articleTitle = getValue(slide, 'articleTitle');
    const articleLink = getValue(slide, 'articleLink');

    return {
      articleImage,
      articleTitle,
      articleLink,
    };
  }
}

/**
 * Parse config contained in slider root element
 * @param {HTMLElement} slider
 */
function parseSliderConfig(slider, type = 'history') {
  let items = getNumberAttribute(slider, 'items', 3);
  timer = getNumberAttribute(slider, 'timer', 0);
  const looping = slider.getAttribute('looping');
  const inview = slider.getAttribute('scroll-in-view');
  let nav = true;
  const dots = false;
  let margin = type != 'history' ? 12 : 24;
  const mouseDrag = true;
  let autoplay = false;
  let loop = false;
  let autoplayHoverPause = true;
  let responsive;
  let autoplayTimeout = 3000;

  if (type == 'thumbs') {
    autoplayHoverPause = false;
    margin = 32;
    items = 5;
    nav = false;
  } else if (type == 'teaser') {
    responsive = {
      0: {
        items: 1,
      },
    };
  } else if (type == 'media') {
    responsive = {
      0: {
        items: 1,
      },
      480: {
        items: items >= 2 ? 2 : items,
      },
      1000: {
        items: items >= 3 ? 3 : items,
      },
      1200: {
        items: items,
      },
    };
  } else {
    responsive = {
      0: {
        items: 1,
      },
      480: {
        items: 2,
      },
      1000: {
        items: 3,
      },
      1200: {
        items: items,
      },
    };
  }

  if (timer > 0) {
    autoplay = true;
    autoplayTimeout = timer * 1000;
  }

  if (looping === 'true' && type !== 'teaser') {
    loop = true;
  }

  if (inview === 'true') {
    autoplay = false;
  }

  return {
    items,
    nav,
    dots,
    margin,
    responsive,
    autoplay,
    autoplayHoverPause,
    autoplayTimeout,
    mouseDrag,
    loop,
  };
}

const restartAutoplay = (slider, time = timer) => {
  if (time > 0) {
    jQuery(slider).trigger('stop.owl.autoplay');
    jQuery(slider).trigger('play.owl.autoplay', [time * 1000]);
  }
};

const syncTeasers = (el) => {
  const thumbId = el.currentTarget.id.split('--')[1];
  const thumbs = jQuery(`#thumbs-${thumbId}`);
  const count = el.item.count;

  let current = el.item.index;
  if (current < 0) {
    current = count;
  }
  if (current > count) {
    current = 0;
  }

  if (timer > 0) {
    jQuery(el.currentTarget).addClass('slider--loading');
    jQuery(el.currentTarget).find('.article__loader').css('transition-duration', `${timer}s`);
  }
  thumbs.find('.owl-item').removeClass('current').eq(current).addClass('current');
  const activeSlide = thumbs.find('.owl-item.active').length - 1;
  const start = thumbs.find('.owl-item.active').first().index();
  const end = thumbs.find('.owl-item.active').last().index();
  if (current > end) {
    thumbs.trigger('to.owl.carousel', [current, 300]);
  }
  if (current < start) {
    thumbs.trigger('to.owl.carousel', [current - activeSlide, 300]);
  }

  updateCounter(count, current, thumbId);
  restartAutoplay(el.currentTarget, timer);
};

const syncThumbs = (el) => {
  const thumbId = el.currentTarget.id.split('--')[1];
  const slideIndex = el.item.index;
  jQuery(`#teaser-slider--${thumbId}`).trigger('to.owl.carousel', [slideIndex, 300]);
};

const adjustSize = (sliderId, thumbsId) => {
  setTimeout(() => {
    const sliderSize = jQuery(`#${sliderId} img`).width();
    if (sliderSize == 0) {
      adjustSize(sliderId, thumbsId);
    }
    jQuery(`#${thumbsId}`).css('width', sliderSize);
    jQuery(`#${thumbsId}`).trigger(`resized.owl.carousel`);
    jQuery(`#${thumbsId}`).trigger(`refresh.owl.carousel`);
  }, 100);
};

const updateCounter = (slidesAmmount, currentSlide, sliderId) => {
  let temp = jQuery(`#teaser-slider--${sliderId}`).find('.slider__counter');
  if (temp.length > 0) {
    temp.text(`${currentSlide + 1} of ${slidesAmmount}`);
  } else {
    temp = `<span class="slider__counter d-lg-none">1 of ${slidesAmmount}</span>`;
  }
  jQuery(`#teaser-slider--${sliderId}`).find('.owl-nav').append(temp);
};

const switchSlide = (event) => {
  event.preventDefault();
  const selectedItem = jQuery(event.currentTarget);
  const slideIndex = selectedItem.index();
  const teaserSlider = selectedItem.closest('.owl-carousel').siblings('.owl-carousel');
  jQuery(teaserSlider).trigger('to.owl.carousel', [slideIndex, 300]);

  restartAutoplay(teaserSlider);
};

const isScrolledIntoView = (elem) => {
  const docViewTop = jQuery(window).scrollTop();
  const docViewBottom = docViewTop + jQuery(window).height();
  const elemTop = jQuery(elem).offset().top;
  const elemBottom = elemTop + jQuery(elem).height();

  return elemBottom <= docViewBottom && elemTop >= docViewTop;
};

const startSliderAutoplay = (slider) => {
  if (isScrolledIntoView(slider)) {
    setTimeout(() => {
      slider.trigger('play.owl.autoplay');
    }, 500);
  }

  jQuery(window).on('scroll', () => {
    if (isScrolledIntoView(slider)) {
      slider.trigger('play.owl.autoplay');
    }
  });
};

export {
  adjustSize,
  parseSlideData,
  parseSliderConfig,
  startSliderAutoplay,
  switchSlide,
  syncTeasers,
  syncThumbs,
  updateCounter,
};
